import { render, staticRenderFns } from "./CompanyDisclosure.vue?vue&type=template&id=8bf71dd4&scoped=true&"
import script from "./CompanyDisclosure.vue?vue&type=script&lang=js&"
export * from "./CompanyDisclosure.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDisclosure.vue?vue&type=style&index=0&id=8bf71dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf71dd4",
  null
  
)

export default component.exports